import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon_bin.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1dc4ab25")

_pushScopeId("data-v-1dc4ab25")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "position-relative",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showBin && _ctx.showBin(...args)))
  }, [
    _createVNode("div", {
      class: ["_pallinoRosso", { _show: _ctx.bin }]
    }, [
      _hoisted_1
    ], 2),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
})